import React from 'react'
import { SacOrigin } from '@/domain/models'
import { Box, CardSwitch, Text } from '@/presentation/components'

type SacOriginSettingsProps = {
  origins?: SacOrigin[]
  visibleOrigins?: string[]
  hasError: boolean
  onChange: (origins: string[]) => void
}

export const SacOriginSettings: React.FC<SacOriginSettingsProps> = ({ origins, visibleOrigins, hasError, onChange }) => {
  const isAvailable = Array.isArray(origins) && Array.isArray(visibleOrigins)

  const toggleOrigin = (code: string): void => {
    const selected = new Set(visibleOrigins)
    if (selected.has(code)) selected.delete(code)
    else selected.add(code)

    onChange((origins ?? []).filter(origin => selected.has(origin.codigo)).map(origin => origin.codigo).sort())
  }

  return (
    <Box>
      <Box style={{ marginHorizontal: 16, marginTop: 16, marginBottom: 8 }}>
        <Text variant='subtitle1'>Origens de SAC visíveis no Portal</Text>
        <Text variant='body2'>Selecione as origens que os clientes podem consultar nesta unidade.</Text>
        {!isAvailable && <Text variant='body2'>Atualize o Integra para configurar as origens de SAC.</Text>}
        {isAvailable && !origins.length && <Text variant='body2'>Nenhuma origem de SAC cadastrada.</Text>}
        {hasError && <Text accessibilityRole='alert'>Selecione ao menos uma origem de SAC.</Text>}
      </Box>
      {isAvailable && origins.map(origin => (
        <CardSwitch
          key={origin.codigo}
          text={`${origin.codigo} - ${origin.descricao}`}
          accessibilityLabel={`${origin.codigo} - ${origin.descricao}`}
          testID={`sac-origem-${origin.codigo}`}
          value={visibleOrigins.includes(origin.codigo)}
          handleSwitch={() => toggleOrigin(origin.codigo)}
        />
      ))}
    </Box>
  )
}
